import Vue from 'vue';

export default {
  getPartnerInfoByName(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/partner/detail/with-orgname', {params});
  }
};
